import { BuInstancesTab } from "@/components/settings/BuInstancesTab";

export function BuInstancesPage() {
  return <BuInstancesTab />;
}
